import { actions } from './actions'

const initialState = {
  fechasColor: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function fechaColorReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FECHA_COLOR_LOAD_REQUESTED:
      return {
        ...state,
        fechasColor: { ...state.fechasColor, loading: true },
      }
    case actions.FECHA_COLOR_LOAD_SUCCEEDED:
      return {
        ...state,
        fechasColor: { ...state.fechasColor, data: action.payload, loading: false },
      }
    case actions.FECHA_COLOR_LOAD_FILED:
      return {
        ...state,
        fechasColor: { ...state.fechasColor, loading: false, error: action.error },
      }
    case actions.FECHA_COLOR_INSERT_REQUESTED:
      return {
        ...state,
        fechasColor: { ...state.fechasColor, loading: true, error: '' },
      }
    case actions.FECHA_COLOR_INSERT_SUCCEEDED:
      return {
        ...state,
        fechasColor: {
          ...state.fechasColor,
          data: [].concat(action.payload, state.fechasColor.data),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_COLOR_INSERT_FILED:
      return {
        ...state,
        fechasColor: { ...state.fechasColor, loading: false, error: action.error },
      }

    case actions.FECHA_COLOR_UPDATE_REQUESTED:
      return {
        ...state,
        fechasColor: { ...state.fechasColor, loading: true, error: '' },
      }
    case actions.FECHA_COLOR_UPDATE_SUCCEEDED:
      return {
        ...state,
        fechasColor: {
          ...state.fechasColor,
          data: state.fechasColor.data.map(fecha =>
            fecha.id === action.payload.id ? action.payload : fecha,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_COLOR_UPDATE_FILED:
      return {
        ...state,
        fechasColor: { ...state.fechasColor, loading: false, error: action.error },
      }

    case actions.FECHA_COLOR_DELETE_REQUESTED:
      return {
        ...state,
        fechasColor: { ...state.fechasColor, loading: true, error: '' },
      }
    case actions.FECHA_COLOR_DELETE_SUCCEEDED:
      return {
        ...state,
        fechasColor: {
          ...state.fechasColor,
          data: state.fechasColor.data.filter(fecha => fecha.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.FECHA_COLOR_DELETE_FILED:
      return {
        ...state,
        fechasColor: { ...state.fechasColor, loading: false, error: action.error },
      }
    default:
      return state
  }
}
